var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "img-comparison-slider",
        { staticClass: "img-comparison-slider br-4 shadow" },
        [
          _c(
            "figure",
            { staticClass: "before", attrs: { slot: "first" }, slot: "first" },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  src: _vm.firstImage,
                  alt: _vm._f("trans")("Before"),
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "figure",
            { staticClass: "after", attrs: { slot: "second" }, slot: "second" },
            [
              _c("img", {
                attrs: {
                  width: "100%",
                  src: _vm.secondImage,
                  alt: _vm._f("trans")("After"),
                },
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }